import type { Campaigns } from "@/types/models/Campaigns";

/** Donation form URL donors use (depends on NEXT_PUBLIC_STAGE). */
export function getCampaignPublicFormUrl(
  campaign: Pick<Campaigns, "accountId" | "externalId">
): string {
  const stage = process.env.NEXT_PUBLIC_STAGE;
  const path = `/form/${campaign.accountId}?campaignId=${campaign.externalId}`;

  if (stage === "dev") {
    const origin =
      process.env.NEXT_PUBLIC_WIDGET_ORIGIN ?? "http://localhost:10000";
    return `${origin}${path}`;
  }
  if (stage === "staging") {
    return `https://staging.form.gogive.com.au${path}`;
  }
  // prod and any unset/unknown stage (e.g. Vercel preview)
  return `https://form.gogive.com.au${path}`;
}

/** Public appeal page URL (`pages.gogive.com.au/{accountSlug}/{campaignSlug}`). */
export function getCampaignPublicPageUrl(params: {
  accountSlug: string;
  campaignSlug: string;
}): string {
  const stage = process.env.NEXT_PUBLIC_STAGE;
  const path = `/${params.accountSlug}/${params.campaignSlug}`;

  if (stage === "dev") {
    const origin =
      process.env.NEXT_PUBLIC_PAGES_ORIGIN ?? "http://localhost:11000";
    return `${origin}${path}`;
  }
  if (stage === "staging") {
    return `https://staging.pages.gogive.com.au${path}`;
  }
  return `https://pages.gogive.com.au${path}`;
}
